<template>
  <transition name="fade">
    <div class="mark-score" v-show="open">
      <div class="mask" @click="close"></div>
      <Block class="mark-score-main" type="scoreBlock">
        <!-- <a href="javascript:;" @click="close" class="mark-score-main-close"></a> -->
        <Button
          type="markScoreMainClose"
          class="mark-score-main-close"
          @click="close"
        ></Button>
        <!-- <Block class="successImg" type="maintainScoreImg"></Block> -->
        <div class="wrap" v-if="!showResult">
          <Block type="scoreStartContainer" class="mark-score-main-stars">
            <ScoreStart
              class="star"
              :class="$platformClass"
              :active="index <= score"
              @click="setScore(index)"
              v-for="(star, index) in starList"
              :key="index"
            ></ScoreStart>
          </Block>
          <Block tagName="p" type="commentTips" class="mark-score-main-tips">
            {{ letters._score }}
          </Block>
          <Button
            type="fillLights"
            class="mark-score-main-confirm text"
            @click="confirmScore"
          >
            <Icon type="commonBtnLeft"></Icon>
            <Icon type="commonBtnRight"></Icon>
            {{ letters._confirm }}
          </Button>
        </div>
        <div class="mark-score-main-result" v-if="showResult">
          <!-- <i class="checked"></i> -->
          <Block class="successImg" type="maintainScoreImg"></Block>
          <div class="mark-score-main-result-stars" :class="$platformClass">
            <ScoreStart
              href="javascript:;"
              class="star"
              :class="$platformClass"
              :active="index <= score"
              @click="setScore(index)"
              v-for="(star, index) in starList"
              :key="index"
            ></ScoreStart>
          </div>
          <Button
            :href="deepLink"
            tagName="a"
            v-if="!isWeb"
            type="supportReturnGame"
            class="mark-score-main-result-back text"
            @click="goGame"
          >
            <!-- <i class="helmet"></i> -->
            <Icon
              v-if="!$isOmni"
              type="supportReturnGameHelmet"
              class="helmet"
            ></Icon>
            <Icon type="commonBtnLeft"></Icon>
            <Icon type="commonBtnRight"></Icon>
            {{ letters._goGame }}
          </Button>
        </div>
      </Block>
    </div>
  </transition>
</template>
<script>
import { mapActions } from 'vuex';
import getLetters from '../../mixins/getLetters.js';
import globalConfig from '../../utiles/globalConfig.js';
export default {
  name: 'mark-score',
  mixins: [getLetters],
  data: function () {
    return {
      showResult: false,
      starList: ['', '', '', '', ''],
      score: -1,
      deepLink: 'about:blank',
      isWeb: globalConfig.getHrefParamUndecode('web') === '1',
    };
  },
  created: function () {
    let sdkToken = globalConfig.getHrefParam('sdkToken');
    this.deepLink = `javascript:window.open('${sdkToken}://')`;
  },
  methods: {
    ...mapActions(['evaluation', 'getWorkDetail']),
    reset: function () {
      this.showResult = false;
      this.score = -1;
    },
    close: function () {
      this.$emit('toggle');
      this.reset();
    },
    setScore: function (index) {
      if (this.showResult) {
        return;
      }
      this.score = index;
    },
    confirmScore: function () {
      let evaluation = this.score + 1;
      let support_order_id = this.support_order_id;
      this.evaluation({ evaluation, support_order_id }).then(res => {
        if (res.result === 1) {
          this.showResult = true;
          this.getWorkDetail(support_order_id);
        }
      });
    },
    goGame: function () {
      this.close();
    },
  },
  props: ['open', 'support_order_id'],
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/support.scss';
@import '../../assets/scss/platform-support.scss';
.checked {
  @include size(190, 190);
  display: inline-block;
  @include bgPng('checked-icon');
  position: absolute;
  left: 91px;
  top: 34px;
}
.star {
  @include size(40, 40);
  display: inline-block;
  @include bgPng('star');
  &-light {
    @include bgPng('star_hover-icon');
  }
  // &:hover {
  //   @include bgPng("star_hover-icon");
  // }
}

.successImg {
  display: none;
}
.mark-score {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  &-main {
    @extend %abs-center;
    @include size(410, 448);
    border: solid 14px #fff;
    @include bgC(#f3f3f3);
    z-index: 10;
    &-close {
      @extend %popup-close;
      position: absolute;
      right: 9px;
      top: 9px;
    }
    &-stars {
      width: 100%;
      position: absolute;
      text-align: center;
      top: 97px;
    }
    &-tips {
      width: 100%;
      position: absolute;
      top: 184px;
      font-size: 24px;
      font-weight: bold;
      color: #414141;
      text-align: center;
    }
    &-confirm {
      @include size(330, 74);
      @include bgC(#5fd193);
      color: #fff;
      position: absolute;

      left: 50%;
      margin-left: -50%;
      bottom: 31px;
    }
    &-result {
      &-stars {
        width: 100%;
        position: absolute;
        text-align: center;
        top: 243px;
      }
      &-back {
        @include size(330, 74);
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        top: 320px;
        @include bgC(#9588e4);
        color: #fff;
        line-height: 74px;
        text-align: center;
      }
    }
  }
}
</style>
